import React, {useEffect, useRef, useState} from 'react';
import {Button} from '../components/Button';
import {CartItem} from '../components/CartItem';
import {DirectoryBar} from '../components/DirectoryBar';
import {Section} from '../components/Section';
import {sumTotalCountOfCarts} from '../components/CartCounterBadge';
import {getCarts, getProductDetail, removeCartItem} from "../apis/products";
import {CartResponse} from '../types/types';
import {postOrders, returnStock} from "../apis/orders";
import {useHistory} from "react-router-dom";
import {useUserDispatch, useUserState} from '../context/UserContext';
import {Checkbox} from "../components/Checkbox";
import {Bridge} from "../plugins/bridge";
import {BRAZE_EVENT} from "../constants/braze";
import qs from "qs";
import getKCPErrorMessage from "../utils/getKCPErrorMessage";
import KakaoPixel from '../plugins/kakao';
import { ButtonEventProperties, ItemEventProperties } from '../types/amplitudeEventProperties';
import {PopUp} from "../components/PopUp";
import {nToast} from "../plugins/reactToast";

function onClicKeepShopping(page : string){
    const buttonEventProperties : ButtonEventProperties = {
        button_page : page
    }

    Bridge.sendAmplitude('keep_shopping_button_clicked', buttonEventProperties);
    Bridge.sendBraze(BRAZE_EVENT.KEEP_SHOPPING_BUTTON_CLICKED, buttonEventProperties);
}

export const CartPage = () => {
    const history = useHistory();
    const [myCart, setMyCart] = useState<CartResponse>({carts: [], deliveryPrice: 0})
    const {isLoggedIn} = useUserState();
    const [cartItems, setCartItems] = useState<string[]>([]);
    const userDispatch = useUserDispatch();
    const query = qs.parse(history.location.search, {ignoreQueryPrefix: true});
    const mounted = useRef(false);
    const [buyCheckPopup, setBuyCheckPopup] = useState(false);
    const [checkMessage, setCheckMessage] = useState<string>('');

    const updateCartItems = (myCart: CartResponse): void => {
        const cartItemIds = myCart.carts
          .filter(item => item.size.currentStock > 0)
          .map(item => item.cartId);
        setCartItems(cartItemIds);
    };

    useEffect(() => {
        getCarts().then(item => {
            var myCart = item.data.payload
            var total_quantity = 0;
            myCart.carts.map(item => total_quantity += item.count)

            Bridge.sendAmplitude('cart_page_viewed', {
                item_id : myCart.carts.map((item) => { return String(item.product.id) }),
                item_name : myCart.carts.map((item) => { return item.product.name }),
                item_category : myCart.carts.map(() => { return '?' }),
                item_color : myCart.carts.map((item) => { return item.product.color }),
                item_gender : myCart.carts.map(() => { return '?' }),
                item_price : myCart.carts.map((item) => { return item.product.initialPrice }),
                item_discount_rate : myCart.carts.map((item) => { return ((item.product.initialPrice - item.product.currentPrice) / item.product.initialPrice) * 100 }),
                item_discount_price : myCart.carts.map((item) => { return item.product.currentPrice }),
                item_size : myCart.carts.map((item) => { return item.size.name }),
                order_item_quantity : myCart.carts.map((item) => { return item.count }),
                total_order_items_quantity : total_quantity
            });

            Bridge.sendBraze(BRAZE_EVENT.CART_PAGE_VIEWED,
                {
                    item_id : myCart.carts.map((item) => { return String(item.product.id) }).join(','),
                    item_name : myCart.carts.map((item) => { return item.product.name }).join(','),
                    item_category : myCart.carts.map(() => { return '?' }).join(','),
                    item_color : myCart.carts.map((item) => { return item.product.color }).join(','),
                    item_gender : myCart.carts.map(() => { return '?' }).join(','),
                    item_price : myCart.carts.map((item) => { return item.product.initialPrice }).join(','),
                    item_discount_rate : myCart.carts.map((item) => { return ((item.product.initialPrice - item.product.currentPrice) / item.product.initialPrice) * 100 }).join(','),
                    item_discount_price : myCart.carts.map((item) => { return item.product.currentPrice }).join(','),
                    item_size : myCart.carts.map((item) => { return item.size.name }).join(','),
                    order_item_quantity : myCart.carts.map((item) => { return item.count }).join(','),
                    total_order_items_quantity : total_quantity
                }
            );
        })
    }, [])

    useEffect(() => {
        if (!!query.code || !!query.message) {
            history.push("/cart")
            alert(getKCPErrorMessage(query.code as string) || query.message as string);
            returnStock().then(r => {
                getCartsListFirst()
            })
        }else{
            getCartsListFirst()
        }
    }, [])

    const getCartsListFirst = () => {
        getCarts().then(r => {
            setMyCart(r.data.payload);
            updateCartItems(r.data.payload);
            KakaoPixel.ViewCart();
        }).catch(e => console.log('getCarts e: ', e))
    }

    const getCartsList = () => {
        getCarts()
          .then(r => {
              setMyCart(r.data.payload);
              userDispatch({type: 'SET_CART_COUNT', payload: sumTotalCountOfCarts(r.data.payload.carts)});
          })
          .catch(e => console.log('getCarts e: ', e));
    }

    const getCartPrice = () => {
        let price = 0
        cartItems.forEach(item => {
            const current = myCart.carts.find(cart => cart.cartId === item)
            price += (current?.product.currentPrice || 0) * (current?.count || 0)
        })
        return price
    }

    const totalPrice = getCartPrice() + myCart.deliveryPrice

    const selectedItemsSize = cartItems.length
    useEffect( ()=> {
        setCheckMessage(
            (myCart.carts.some(cart => cart.product.onlyOne)? (selectedItemsSize == 1 ? '✅ 해당 상품은 단독구매상품입니다.\n' : '✅ 단독구매상품이 포함 되어 있습니다.\n') : '')
            + (myCart.carts.some(cart => cart.product.unavailableMileage)? (selectedItemsSize == 1 ? '✅ 해당 상품은 적립금 사용/적립이 불가능 합니다.\n' : '✅ 적립금 사용/적립 불가 상품이 포함 되어 있습니다.\n') : '')
            + (myCart.carts.some(cart => cart.product.unavailableCoupon)? (selectedItemsSize == 1 ? '✅ 해당 상품은 쿠폰 사용이 불가능 합니다.\n' : '✅ 쿠폰 사용 불가 상품이 포함 되어 있습니다.\n') : '')
        )
    })

    const orderStart = (isMember : boolean, tab : string) => {
        const items = myCart.carts.filter(item => cartItems.includes(item.cartId))
        if(items.some(
            cart => cart.product.onlyOne || cart.product.unavailableMileage || cart.product.unavailableCoupon
        ) && !buyCheckPopup){
            setBuyCheckPopup(true)
            return;
        }

        Bridge.sendAmplitude('purchase_button_clicked', {
            'non_member_order' : !isMember,
            'purchase_tab' : tab
        });
        Bridge.sendBraze(BRAZE_EVENT.PURCHASE_BUTTON_CLICKED, {
            'non_member_order' : !isMember,
            'purchase_tab' : tab
        });
        postOrders(cartItems).then(r => history.push('/cart/payment')).catch(e => console.log('postOrders e: ', e))
    }

    const isAllSelected = cartItems.length === myCart.carts.length;

    const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const {checked} = e.target;
        if (checked) {
            setCartItems(myCart.carts.map(item => item.cartId));
        } else {
            setCartItems([]);
        }
    }

    const deleteCheckedItems = () => {
        const items = myCart.carts.filter(item => cartItems.includes(item.cartId))
        var total_cart = myCart.carts.length
        items.forEach(item => {
            removeCartItem(item.product.id, item.size.id).then(async r => {
                const product = item.product;
                Bridge.sendBraze(BRAZE_EVENT.DELETED_FROM_CART, {
                    item_id: String(product?.id),
                    item_name: String(product?.name),
                    item_category: await getProductDetail(product.id).then((data) => {return data.data.payload.categoryCode}),
                    item_color: String(product?.color),
                    item_gender: await getProductDetail(product.id).then((data) => {return data.data.payload.genderCode}),
                    item_size: item.size,
                    item_price: Number(product?.initialPrice),
                    item_discount_rate: Number(((1 - product?.currentPrice / product?.initialPrice)) * 100),
                    item_discount_price: Number(product?.currentPrice),
                    order_item_quantity: item.count
                });

                total_cart -= item.count;
                Bridge.sendAmplitude('setUserProperties#total_cart_items_count', total_cart);

                Bridge.sendAmplitude('item_deleted_to_cart', {
                    item_id: [String(product?.id)],
                    item_name: [String(product?.name)],
                    item_category: [await getProductDetail(product.id).then((data) => {return data.data.payload.categoryCode})],
                    item_color: [String(product?.color)],
                    item_gender: [await getProductDetail(product.id).then((data) => {return data.data.payload.genderCode})],
                    item_price: [Number(product?.initialPrice)],
                    item_discount_rate: [Number((1 - product?.currentPrice / product?.initialPrice)) * 100],
                    item_discount_price: [Number(product?.currentPrice)],
                    order_item_quantity: [item.count]
                });
                getCartsList();
            }).catch(e => console.log(e))
        })
    }

    return (
        <>
            <DirectoryBar text="홈, 장바구니"/>

            <div className="max-w-screen-xl mx-auto">
                <div className="flex space-x-2 items-center py-7 md:pb-4">
                    <h6 className="text-14 font-bold">장바구니</h6>
                    <div className="wh-4 bg-gray-200 rounded-full text-12 grid place-content-center font-bold">
                        {sumTotalCountOfCarts(myCart.carts)}
                    </div>
                </div>

                <div className={'flex justify-between pb-10'}>
                    <Checkbox className="bg-white border border-gray-300"
                              checked={isAllSelected}
                              onChange={handleCheckboxChange}
                              label={'전체선택'}
                    />
                    <button className={'text-14'} onClick={deleteCheckedItems}>선택상품 삭제</button>
                </div>

                {myCart.carts.length === 0 ? (
                  <div className="text-center py-16">
                      <h4 data-aos="fade-in" data-aos-delay="900">장바구니에 담은 상품이 없습니다.</h4>
                  </div>
                ) : (
                  <div className="space-y-5">
                      {myCart.carts.map((item, index) => (
                        <CartItem
                          key={index}
                          item={item}
                          onChange={getCartsList}
                          checked={cartItems.findIndex(cartItem => cartItem === item.cartId) > -1}
                          onChecked={() => {
                              if (cartItems.findIndex(cartItem => cartItem === item.cartId) > -1) {
                                  let list = cartItems.filter(cartItem => cartItem !== item.cartId)
                                  setCartItems(list)
                              } else {
                                  setCartItems([...cartItems, item.cartId])
                              }
                          }}
                        />
                      ))}
                  </div>
                )}

                <Section className="border-t pt-4 mt-8 grid md:place-content-end text-14">
                    <div className="flex justify-between md:space-x-16">
                        <div className="space-y-1">
                            <p className="">총 주문금액</p>
                            <p className="">배송비</p>
                            <p className="font-bold text-18 pt-4">총 주문금액</p>
                        </div>

                        <div className="space-y-1 text-right">
                            <p className="font-bold">{myCart.carts.length === 0 ? '-' : getCartPrice().toLocaleString()}원</p>
                            <p className="font-bold">{myCart.carts.length === 0 ? '-' : myCart.deliveryPrice.toLocaleString()}원</p>
                            <p className="font-bold text-18 pt-4">{myCart.carts.length === 0 ? '-' : totalPrice.toLocaleString()}원</p>
                        </div>
                    </div>
                </Section>

                <Section className="md:w-1/2 mx-auto space-y-6 text-center">
                    {isLoggedIn ? (
                        <div className="flex flex-col mt-16 md:w-1/2 mx-auto">
                            <Button disabled={cartItems.length === 0} onClick={()=>orderStart(isLoggedIn, '회원')}

                                    className="filled-brand-1 font-bold">
                                회원 구매
                            </Button>
                        </div>
                    ) : (
                        <>
                            <div className="grid md:grid-cols-2 gap-4 mt-16">
                                <Button disabled={cartItems.length === 0} onClick={()=>orderStart(Boolean(isLoggedIn), '비회원')}
                                        className="bg-gray-100 font-bold">
                                    비회원 구매
                                </Button>
                                <Button onClick={() => {onClickPurchase(Boolean(isLoggedIn), '회원') && history.push('/login?location=/cart')}} className="filled-brand-1 font-bold">
                                    회원 구매
                                </Button>
                            </div>
                        </>
                    )}

                    <button className="text-13 underline" onClick={() => {onClicKeepShopping('장바구니'); history.push('/')}}>계속 쇼핑하기</button>
                </Section>
            </div>
            <PopUp
                title="아래 내용을 확인해 주세요."
                description={checkMessage}
                buttonText="동의하고 구매하기"
                open={buyCheckPopup}
                onClose={() => setBuyCheckPopup(false)}
                onClick={() => orderStart(Boolean(isLoggedIn), '회원')}
                onClickMobile={() => orderStart(Boolean(isLoggedIn), '회원')}
            />
        </>
    );
};
function onClickPurchase(isMember : boolean, tab : string) {
    Bridge.sendAmplitude('purchase_button_clicked', {
        'non_member_order' : !isMember,
        'purchase_tab' : tab
    });
    Bridge.sendBraze(BRAZE_EVENT.PURCHASE_BUTTON_CLICKED, {
        'non_member_order' : !isMember,
        'purchase_tab' : tab
    });
    return true
}

